import { cn } from '@/lib/core/utils/cn';

export function SpinLoading({
  wrapperClassName,
  spinnerClassName,
}: {
  wrapperClassName?: string;
  spinnerClassName?: string;
}) {
  return (
    <div className={cn('flex min-h-screen items-center justify-center', wrapperClassName)}>
      <div
        className={cn(
          'border-jncquoi-neutral-1000 h-8 w-8 animate-spin rounded-full border-b-2',
          spinnerClassName
        )}
      />
    </div>
  );
}
